import React from 'react';
import Meaning from './Meaning';
import Phonetics from './Phonetics';
import './Results.css';

export default function Results(props) {
  if (props.results) {
    return (
      <div className="Results">
        <section>
          <h1>{props.results.word}</h1>
          <Phonetics phonetics={props.results.phonetics} />
          {props.results.meanings.map(function (meaning, index) {
            return (
              <div key={index}>
                <Meaning meaning={meaning} />
              </div>
            );
          })}{' '}
        </section>
      </div>
    );
  } else {
    return null;
  }
}
